export function Footer({ content, logoUrl }) {
  const c = content || {};
  return (
    <footer className="border-t border-border bg-card/40 mt-16" data-testid="site-footer">
      <div className="container py-8 md:py-12">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <h3 className="font-heading font-semibold text-lg">{c.brand_name || "eLearningSaham"}</h3>
            <p className="text-xs text-muted-foreground tracking-widest uppercase mt-1">{c.brand_subtitle || "by Maahad Bursa"}</p>
            <p className="mt-4 text-sm text-muted-foreground leading-relaxed">
              {c.description || "Portal eLearningSaham by Maahad Bursa — a Shariah-compliant stock learning platform."}
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3">Contact</h4>
            <p className="text-sm text-muted-foreground">{c.contact_email || "support@maahadbursa.my"}</p>
            <p className="text-sm text-muted-foreground mt-1">{c.domain || "elearningsaham.my"}</p>
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3">Disclaimer</h4>
            <p className="text-xs text-muted-foreground leading-relaxed">
              {c.disclaimer || "This content is for educational purposes only and is not specific investment advice. Investment decisions are the responsibility of the individual."}
            </p>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-border/60 text-xs text-muted-foreground text-center">
          © {new Date().getFullYear()} {c.copyright || "eLearningSaham by Maahad Bursa. All rights reserved."}
        </div>
      </div>
    </footer>
  );
}
